import type { Control } from "react-hook-form";

import { adminProviders } from "~/services";
import { CsvUploadField, EditProviderScheduleDescriptionField } from ".";

type EditProviderScheduleFormFieldsProps = {
  control: Control<adminProviders.UploadProviderScheduleParams>;
};

export const EditProviderScheduleFormFields = ({
  control,
}: EditProviderScheduleFormFieldsProps) => (
  <div className="border-light-lavender-gray flex w-full flex-col gap-4 border-t py-4">
    <EditProviderScheduleDescriptionField control={control} />
    <CsvUploadField control={control} />
  </div>
);
